import { Select } from 'antd';
import type { RolesFilterProps } from '../reports.types';

const { Option } = Select;

const RolesFilter = ({ roles, selectedRoles, onChange }: RolesFilterProps) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ userSelect: 'none', fontSize: '14px' }}>Роли для отчета:</span>
      <Select
        mode="multiple"
        style={{ width: 600 }}
        placeholder="Выберите роли для включения"
        value={selectedRoles}
        onChange={onChange}
        optionLabelProp="label"
        loading={!roles.length}
      >
        {roles.map((role) => (
          <Option key={role.id} value={role.id} label={role.name}>
            {role.name}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default RolesFilter;
